import React, { useState } from 'react';
import { Container, ModalContainer, Layer, ModalHeader, ModalHeaderTitle, ButtonContainer, CloseIconWrapper } from './style';
import { ButtonGradient, ButtonLabel } from '../Buttons';
import { THEME_COLORS } from '../../styles/theme';
import { Icons } from '../Icons';

export const Popup = ({ 
    close, title = "", children, buttonText = "", 
    large = false, isExtraLarge = false,
    isDismissableBackground = true,
    hasBottomButton = true,
    buttonCallback = () => {}, 
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const overrideClose = () => {
        setIsClosing(true);
        setTimeout(close, 200);
    }
    return (
        <Container>
            <Layer onClick={() => {
                if (!isDismissableBackground) return;
                overrideClose();
            }} isClosing={isClosing} />
            <ModalContainer 
                isClosing={isClosing} 
                large={large} 
                isExtraLarge={isExtraLarge}
                hasBottomButton={hasBottomButton}
            >
                <ModalHeader>
                    <ModalHeaderTitle>{title}</ModalHeaderTitle>
                    <CloseIconWrapper onClick={overrideClose}>
                        <Icons icon="Cross" color={THEME_COLORS.darkBlue} />
                    </CloseIconWrapper>
                </ModalHeader>
                <div style={{ overflowY: 'auto' }}>
                    {children}
                </div>
                {hasBottomButton &&
                    <ButtonContainer>
                        <ButtonGradient mainColor={THEME_COLORS.pinkOrange} onClick={() => {
                            overrideClose();
                            buttonCallback();
                        }}>
                            <ButtonLabel>{buttonText}</ButtonLabel>
                        </ButtonGradient>
                    </ButtonContainer>
                }
            </ModalContainer>
        </Container>
    );  
}